import React from 'react';

const steps = [
  { num: '01', title: 'DESCUBRIMIENTO', desc: 'Analizamos tu negocio, objetivos y audiencia para definir la estrategia perfecta.' },
  { num: '02', title: 'DISEÑO', desc: 'Creamos prototipos y diseños que reflejan tu marca con impacto visual.' },
  { num: '03', title: 'DESARROLLO', desc: 'Construimos con las mejores tecnologías, optimizado para rendimiento.' },
  { num: '04', title: 'LANZAMIENTO', desc: 'Desplegamos, monitoreamos y optimizamos para resultados reales.' },
];

const Process = () => (
  <section className="process" id="proceso">
    <div className="process__inner">
      <div className="reveal">
        <div className="section-label">Nuestro Proceso</div>
        <h2 className="section-title">CÓMO<br />TRABAJAMOS</h2>
      </div>
      <div className="process__steps reveal">
        {steps.map((s) => (
          <div className="process-step" key={s.num}>
            <div className="process-step__num">{s.num}</div>
            <h3 className="process-step__title">{s.title}</h3>
            <p className="process-step__desc">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
